import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Form_19 from '../Forms/Form_19';
// Import all the forms for Section 3

const Section3 = () => {
  const { formId } = useParams(); // Get the form ID from the route
  const navigate = useNavigate();
  
  const handleBackToForms = () => {
    navigate('/inspections/forms');
  };

  return (
    <div className="p-0 max-w-7xl mx-auto">
      <button
        onClick={handleBackToForms}
        className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
        >
          ← Back to Forms
      </button>

      <h2 className="text-2xl font-semibold mb-6">Section 3</h2>
      {/* Add conditional rendering for all Section 3 forms based on formId */}
      {/* Example: {formId === 'form19' && <Form_19 />} */}
      {formId === 'form19' && <Form_19 />}

    </div>
  );
};

export default Section3;
